module.exports = __webpack_public_path__ + "static/media/1033161.439c1596.jpg";